import 'apps/hiring/styles/components/edit-target-employees.scss';
import React, { useState, Fragment } from 'react';
import { array, func, number, string, object } from 'prop-types';
import { resolve } from 'library/helpers/path-resolver';
import { InputEvent } from 'library/helpers/synthetic-events';
import CloseSvg from 'library/icons/close.svg';
import AddItem from 'library/components/add-item';
import ConfirmInPlace from 'library/components/confirm-in-place';

const EmployeeListItem = (props) => {
  const [active, setActive] = useState(false);

  const toggle = (id) => {
    props.onChange(new InputEvent({
      value: !props.removed_top[id],
      name: `removed_top_assessments/${id}`,
      type: 'reload'
    }));
  };

  const handleOnComplete = (response, assessement) => {
    if (response) {
      toggle(assessement.id);
    }
    setActive(false);
  };

  return (
    <Fragment>
      { !active && (
        <div key={props.id} className={['edit-target-employee', props.removed_top[props.id]?'removed':null].filter(c=>c).join(' ')}>
          <span className="edit-target-employee-name">
            {[props.user.first_name, props.user.last_name].filter(c=>c).join(' ')}
          </span>
          <span className="edit-target-employee-score">
            { resolve(props.user, 'match', 0) }
          </span>
          <button onClick={() => setActive(true)} className="button-noborder-tertiary">
            {
              props.removed_top[props.id]
                ? '+'
                : <CloseSvg />
            }
          </button>
        </div>
      )}
      <ConfirmInPlace
        active={active}
        onComplete={(response) => handleOnComplete(response, {id: props.id, assessement: props.user})}
        noButtonStyle
        text='Remove & Recalculate?'
        style={{padding: '.35em 0'}}
      />
    </Fragment>
  );
};

EmployeeListItem.propTypes = {
  handleRemoveEmployee: func,
  onChange: func,
  onSave: func,
  removed_top: object,
  id: number,
  user: object
};

const EditTargetEmployees = (props) => {

  const mapEmployees = ({id, user}) => {
    return (
      <EmployeeListItem id={id} user={user} {...props} />
    );
  };

  return (
    <section>
      <label>
        Employees in Target <AddItem handleAdd={props.onAddEmployee}/>
      </label>
      <div className="edit-target-employees">
        {
          props.employees.map(mapEmployees)
        }
      </div>
    </section>
  );
};

EditTargetEmployees.propTypes = {
  id: string,
  user: object,
  onChange: func,
  onAddEmployee: func,
  target: object,
  onRemoveEmployee: func,
  employees: array,
  reloadGraph: func,
  removed_top: object,
};

export default EditTargetEmployees;
